import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { shallowEqual} from 'react-redux'
import '../Workflow.scss'
import LoadingTextValue from '../../../../../components/library/layout/LoadingTextValue';
import { useInterviewInfo } from '../../hooks/useInterviewInfoHook';
import { useTaskStatus } from '../../hooks/useTaskStatusHook';
import { WorkflowTasks } from '../../../services/WorkflowTasks';
import AdditionalDocumentRow from './AdditionalDocumentRow';
import HrbTranslate from '../../../../../components/language/HrbTranslate';
import { TaskStatus } from '../../../services/TaskStatus';
import { createInProgressTaskCompletionObject } from '../../../services/prepare/PrepareUtils';

const AddOnProducts = (props) => {

    const { ticket, disabled } = props;

    const [returnType, , province, primaryName, spouseName] = useInterviewInfo(ticket);
    const [status, completions] = useTaskStatus(props.ticket, [WorkflowTasks.RETURN_PREPARED]);
    const [isCoupled, setIsCoupled] = useState(false);
    const [showAdditionalDocuments, setShowAdditionalDocuments] = useState(false)
    const [documentMap, setDocumentMap] = useState({})
    const [isDisabled, setIsDisabled] = useState(true);

    const [timeoutRef, setTimeoutRef] = useState(null);

    useEffect(() => {
        setIsCoupled(returnType === 'coupled')
    }, [returnType])

    useEffect(() => {
        if (completions && completions.length > 0) {
            var validCompletions = completions.filter(c => c.status !== TaskStatus.INVALID)
            let docData = validCompletions[0] && validCompletions[0].completionData ? JSON.parse(validCompletions[0].completionData) : {}
            var docMap = createDocMap(docData);
            if (!shallowEqual(docMap, documentMap)) {
                setDocumentMap(docMap)
            }
            var hasSelectedObject = false
            Object.keys(docData).forEach(k => {
                if (docData[k] !== null) {
                    hasSelectedObject = true
                }
            })
            if ((hasSelectedObject && !showAdditionalDocuments)) {
                setShowAdditionalDocuments(true);
            }
        }
    }, [status])

    useEffect(() => {
        setIsDisabled(status === TaskStatus.NOT_STARTED || disabled);
    }, [status, disabled])

    useEffect(() => {
        if (showAdditionalDocuments && !props.hasUploadedFiles) {
            setShowAdditionalDocuments(false)
            setDocumentMap({})
        }
    }, [props.hasUploadedFiles])

    const createDocMap = (docData) => {
        var docMap = {}
        if (docData.additionalDocuments) {
            Object.keys(docData.additionalDocuments).forEach(k => {
                docMap[k] = Boolean(docData.additionalDocuments[k])
            })
        }
        return docMap
    }

    const handleSetShowDocuments = () => {
        if (!isDisabled) {
            setShowAdditionalDocuments(true)
        }
    }

    const saveChanges = async (docMap) => {
        setTimeoutRef(null);

        var completion = (completions || []).find(x => x.status !== TaskStatus.INVALID)
        var payload = createInProgressTaskCompletionObject(completion, docMap, props.hasUploadedFiles)
        if (completion && completion.status) {
            payload.status = completion.status
        }
        if (props.onSaveCompletion) {
            await props.onSaveCompletion(payload);
        }
    }

    const handleCheck = (elementId, checked) => {
        var dmap = { ...documentMap }
        dmap[elementId.slice(3)] = checked;
        if (!shallowEqual(dmap, documentMap)) {
            setDocumentMap(dmap)

            if (timeoutRef) {
                clearTimeout(timeoutRef);
            }
            setTimeoutRef(setTimeout(() => saveChanges(dmap), 1400));
        }
    }

    return showAdditionalDocuments ? (
        <Fragment>
            <div className='columns prep-section'>
                <div className='column is-offset-1 is-10'>
                    <p className='p2'><HrbTranslate text='PaymentTask.Step1DescAlt1' /></p>                    
                </div>                
            </div>
            <div className='columns prep-section'>
                <div className='column is-offset-1 is-10'>
                    <p className='p2'><HrbTranslate text='PaymentTask.Step1DescAlt2' /></p>
                </div>
            </div>
            <div className='columns'>
                <div className={classnames('column is-offset-1', { 'is-4': isCoupled, 'is-10': !isCoupled })}>
                    <h4><LoadingTextValue value={primaryName} /></h4>
                </div>
                {isCoupled &&
                    <div className='column is-4'>
                        <h4><LoadingTextValue value={spouseName} /></h4>
                    </div>
                }
            </div>
            
            {province !== 'QC' &&
            <AdditionalDocumentRow formId='POMA' isCoupled={isCoupled} onChecked={handleCheck}
                documentMap={documentMap} isDisabled={isDisabled} prefix='addon' />
            }
            {province === 'QC' &&
            <AdditionalDocumentRow formId='POMQCA' isCoupled={isCoupled} onChecked={handleCheck}
                documentMap={documentMap} isDisabled={isDisabled} prefix='addon' />
            }
        </Fragment>
    ) : (
            <Fragment>
                <div className='columns prep-section'>
                    <div className='column is-offset-1 is-10'>
                        <p className='p2'><HrbTranslate text='PaymentTask.Description1' /></p>
                    </div>
                </div>
                <div className='columns prep-section'>
                    <div className='column has-text-centered is-offset-1 is-10'>
                        <a onClick={handleSetShowDocuments} className={isDisabled? 'disabled' : ''}><HrbTranslate text='PaymentTask.Step1FormsLink' allowSelection={!isDisabled}/></a>
                    </div>
                </div>
            </Fragment>
        )
}

AddOnProducts.whyDidYouRender = false;

AddOnProducts.propTypes = {
    ticket: PropTypes.object,
    hasUploadedFiles: PropTypes.bool,
    onSaveCompletion: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    onSavePending: PropTypes.func.isRequired
}

export default AddOnProducts